import { __assign, __rest } from "tslib";
import * as React from 'react';
import cx from 'classnames';
var Icon = React.forwardRef(function (_a, ref) {
    var className = _a.className, spin = _a.spin, type = _a.type, otherProps = __rest(_a, ["className", "spin", "type"]);
    return (React.createElement("i", __assign({ ref: ref, className: cx('zenticon', "zenticon-" + type, className, {
            'zenticon-spin': spin,
        }) }, otherProps, { "data-zv": '8.0.0' })));
});
Icon.displayName = 'ZentIcon';
export { Icon };
export default Icon;
